<script>
import { mapGetters } from "vuex";
import moment from "moment";
import * as Helper from "@/modules/helper/index";
import { isPhoneGap } from '@/modules/util/util'
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    addDays: {
      type: Number,
      default: ""
    },
    allowOnlyFutureDates: {
      type: Boolean,
      default: false
    },
    date: {
      type: String,
      default: ""
    },
    defaultValue: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: ""
    },
    value: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String,
      default: "" // default
    }
  },
  data() {
    return {
      pickerelement: null
    };
  },
  computed: {
    ...mapGetters(["language", "resource"]),
    pickerId() {
      return "picker-date-" + this.index;
    },
    defaultDate() {
      let Date;
      if (this.defaultValue === "current") {
        Date = Helper.ConvertToMyZone();
      } else if (this.defaultValue === "addDays") {
        Date = Helper.ConvertToMyZone();
        Date = Date.add(this.addDays, "d");
      } else if (this.defaultValue === "date") {
        Date = Helper.ConvertToMyZone(this.date);
      } else {
        Date = null;
      }
      return Date;
    },
    defaultDateValue() {
      if (Helper.IsDevSim()) {
        let Date;
        if (this.defaultValue === "current") {
          Date = Helper.ConvertToMyZone();
        } else if (this.defaultValue === "addDays") {
          Date = Helper.ConvertToMyZone();
          Date = Date.add(this.addDays, "d");
        } else if (this.defaultValue === "date") {
          Date = Helper.ConvertToMyZone(this.date);
        } else {
          Date = null;
        }
        return Date != null ? Helper.FormattedDateDDMMMMYY(Date) : Date
      } else {
        if (this.value !== null && this.value !== "") {
          return Helper.FormattedDateDDMMMMYY(this.value)
        }
      }
      // if (this.value !== null && this.value !== "") {
      //   return Helper.FormattedDateDDMMMMYY(this.value)
      // }
    },
    IsNullOrEmptyErrorMessage() {
      if (this.required && !Helper.IsNullOrEmpty(this.value)) {
        return true;
      }
    }
  },
  watch: {
    defaultValue: function(value, oldvalue) {
      if (value !== oldvalue && this.pickerelement) {
        this.pickerelement.destroy();
        this.pickerelement = null;
      }
      this.createDatePicker();
    },
    addDays: function(value, oldvalue) {
      if (value !== oldvalue && this.pickerelement) {
        this.pickerelement.destroy();
        this.pickerelement = null;
      }
      this.createDatePicker();
    },
    date: function(value, oldvalue) {
      if (value !== oldvalue && this.pickerelement) {
        this.pickerelement.destroy();
        this.pickerelement = null;
      }
      this.createDatePicker();
    }
  },
  methods: {
    createDatePicker() {
      let $this = this;
      if (this.pickerelement === null) {
        this.pickerelement = this.$f7.picker.create({
          inputEl: '#' + this.pickerId,
          rotateEffect: true,
          openIn: "sheet",
          toolbarCloseText: this.resource.doneBtn,
          routableModals: false,
          value: this.setDefault(),
          on: {
            change: function(picker, values, displayValue) {
              let date = moment(new Date( 
                picker.value[2] + "-" + (picker.value[1] * 1 + 1) + "-" + "1")
              ); // YYYY-MM-DD
              if ($this.allowOnlyFutureDates) {
                let currentDate = Helper.CurrentDateTime();
                let flag = currentDate.isSameOrBefore(
                  picker.value[2] +
                    "-" +
                    (picker.value[1] * 1 + 1) +
                    "-" +
                    picker.value[0],
                  "day"
                );
                if (!flag) {
                  picker.setValue([
                    currentDate.date(),
                    currentDate.month() + "",
                    currentDate.year()
                  ]);
                }
              }
              var daysInMonth = date.daysInMonth();
              if (values[0] > daysInMonth) {
                picker.cols[0].setValue(daysInMonth);
              }
              let dateint = parseInt(values[0])
              let monthint = parseInt(values[1]) + 1
              let yearint = parseInt(values[2])
              let dt =  yearint +  "-" + (monthint >= 10 ? monthint : 0 + ("0" + monthint).slice(-1)) + "-" + (dateint >= 10 ? dateint : 0 + ("0" + dateint).slice(-1))
              let formateddate = moment(dt).format('YYYY-MM-DD'); // YYYY-MM-DD
              $this.$emit("propChange", {
                value: formateddate
              });
            },
            close: function(picker) {
              let dateint = parseInt(picker.value[0])
              let monthint = parseInt(picker.value[1]) + 1
              let yearint = parseInt(picker.value[2]) 
              let dt =  yearint +  "-" + (monthint >= 10 ? monthint : 0 + ("0" + monthint).slice(-1)) + "-" + (dateint >= 10 ? dateint : 0 + ("0" + dateint).slice(-1))
              let formateddate = moment(dt).format('YYYY-MM-DD'); // YYYY-MM-DD
              $this.$emit("propChange", {
                value: formateddate
              });
            },
            open: function() {
              if (isPhoneGap() && Keyboard) {
                Keyboard.hide()
              }
            }
          },
          formatValue: function(values, displayValue) {
            if ($this.language === "de") {
              return (
                (displayValue[0] >= 10 ? displayValue[0] : 0 + displayValue[0]) +
                ". " +
                values[1] +
                " " +
                values[2]
              );
            } else {
              return (
                (displayValue[0] >= 10 ? displayValue[0] : 0 + values[0]) +
                " " +
                values[1] +
                " " +
                values[2]
              );
            }
          },
          cols: [
            // Days
            {
              values: Helper.getMonthDays()
            },
            // Months
            {
              values: "0 1 2 3 4 5 6 7 8 9 10 11".split(" "),
              displayValues: Helper.getMonthNames(),
              textAlign: "left"
            },
            // Years
            {
              values: Helper.getYears()
            }
          ]
        });
      }
    },
    setDefault() {
      if (this.defaultDate === null) {
        return "";
      } else {
        return [
          this.defaultDate.date(),
          this.defaultDate.month() + "",
          this.defaultDate.year()
        ];
      }
    }
  },
  created () {
    if (this.defaultDateValue){
      this.$emit("propChange", {
      value: this.defaultDateValue
    });
    }
  },
  mounted() {
    this.createDatePicker();
  },
  beforeDestroy() {
    if (this.pickerelement) {
      this.pickerelement.destroy();
    }
  }
};
</script>

<template>
   <f7-list class="list-block inputs-list">
      <f7-list-item class="input-wrapper">
         <f7-label class="label-color">{{label}}</f7-label>
         <f7-input type="text" :placeholder="placeholder" v-model="defaultDateValue" :id="pickerId" :readonly="true" class="input-value-color"></f7-input>
         <!-- <span v-if="!IsNullOrEmptyErrorMessage" class="color-red">{{errorMessage}}</span> -->
         <div v-if="!IsNullOrEmptyErrorMessage" class="color-red">{{errorMessage}}</div>
      </f7-list-item>

   </f7-list>
</template>

<style scoped>
.list {
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/DateInput.vue